(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };

  /* ---------- Skip intro ---------- */
  var skip = $('.curtain__skip');
  if (skip) skip.addEventListener('click', function () { root.classList.add('no-curtain'); });

  /* ---------- Full-screen menu ---------- */
  var menuBtn = $('.menu-btn'), overlay = $('#menu-overlay');
  if (menuBtn && overlay) {
    var setMenu = function (open) {
      d.body.classList.toggle('menu-open', open);
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      menuBtn.firstElementChild.textContent = open ? 'Close' : 'Menu';
      overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    };
    menuBtn.addEventListener('click', function () { setMenu(!d.body.classList.contains('menu-open')); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    overlay.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
  }

  /* ---------- Split big text into masked words ---------- */
  $$('[data-words]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.setAttribute('aria-label', words.join(' '));
    el.innerHTML = words.map(function (w, i) {
      return '<span class="w" aria-hidden="true"><span style="--w:' + i + '">' + w.replace(/</g, '&lt;') + '</span></span>';
    }).join(' ');
  });

  /* ---------- Tag elements for entrance effects ---------- */
  $$('.disco__item, .social-link, .post, .store__item').forEach(function (t, i) {
    t.classList.add('reveal', 'reveal--tile'); t.style.setProperty('--i', i % 4);
  });
  $$('.release__cover img, .release__cover .placeholder, .about__portrait img, .about__portrait .placeholder').forEach(function (el) { el.classList.add('wipe'); });
  $$('.section h2.chrome-text').forEach(function (el) { el.classList.add('sweep'); });
  $$('.footer__mark, .plats, .player').forEach(function (el) { el.classList.add('reveal'); });

  /* ---------- Matrix rain + particles (canvas) ---------- */
  function Rain(canvas, o) {
    o = o || {};
    var ctx = canvas.getContext('2d'), w = 0, h = 0, drops = [], run = false, last = 0, parts = [];
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5), size = o.size || 16;
    var glyphs = o.glyphs || 'ｱｲｳｴｵｶｷｸｹｺ0123456789';
    function resize() {
      var r = canvas.getBoundingClientRect();
      w = canvas.width = Math.max(1, Math.floor(r.width * dpr));
      h = canvas.height = Math.max(1, Math.floor(r.height * dpr));
      var cols = Math.ceil(w / (size * dpr));
      drops = []; for (var i = 0; i < cols; i++) drops.push(-Math.random() * 40);
      parts = [];
      for (var p = 0; p < (o.particles || 0); p++) parts.push({ x: Math.random() * w, y: Math.random() * h, r: (Math.random() * 1.4 + .4) * dpr, vx: (Math.random() - .5) * .25 * dpr, vy: -(Math.random() * .35 + .08) * dpr, a: Math.random() * .6 + .2 });
    }
    function frame(t) {
      if (!run) return;
      requestAnimationFrame(frame);
      if (t - last < 1000 / (o.fps || 24)) return;
      last = t;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,' + (o.fade || .1) + ')';
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'source-over';
      var s = size * dpr;
      ctx.font = s + 'px monospace';
      for (var i = 0; i < drops.length; i++) {
        var ch = glyphs.charAt(Math.floor(Math.random() * glyphs.length));
        var y = drops[i] * s;
        var green = Math.random() < (o.ghost || .05);
        ctx.fillStyle = green ? 'rgba(245,215,110,.75)' : (Math.random() < .08 ? 'rgba(232,238,238,.9)' : 'rgba(212,175,55,.8)');
        ctx.fillText(ch, i * s, y);
        if (y > h && Math.random() > .975) drops[i] = 0;
        drops[i] += o.speed || .6;
      }
      for (var p = 0; p < parts.length; p++) {
        var q = parts[p]; q.x += q.vx; q.y += q.vy;
        if (q.y < -4) { q.y = h + 4; q.x = Math.random() * w; }
        ctx.fillStyle = 'rgba(72,255,240,' + q.a + ')';
        ctx.beginPath(); ctx.arc(q.x, q.y, q.r, 0, 6.283); ctx.fill();
      }
    }
    resize();
    return {
      start: function () { if (run || reduce || saveData) return; run = true; requestAnimationFrame(frame); },
      stop: function () { run = false; },
      resize: resize,
      clear: function () { ctx.clearRect(0, 0, w, h); }
    };
  }
  var rains = [];
  function watchRain(canvas, opts, vis) {
    if (!canvas || reduce || saveData || !canvas.getContext) return null;
    var r = Rain(canvas, opts); rains.push(r);
    if (vis !== false && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es[0].isIntersecting ? r.start() : r.stop(); }, { threshold: 0 }).observe(canvas);
    }
    return r;
  }
  var small = window.innerWidth < 800;
  watchRain($('[data-fx]'), { size: small ? 14 : 18, fade: .09, fps: 22, speed: .5, particles: small ? 18 : 42, ghost: .06 });
  var portalRains = [];
  $$('[data-portal]').forEach(function (s) {
    var r = watchRain($('[data-rain]', s), { size: small ? 14 : 18, fade: .08, fps: 24, speed: .8, ghost: .08 }, false);
    s._rain = r; if (r) portalRains.push(r);
  });
  window.addEventListener('resize', function () { rains.forEach(function (r) { r.resize(); }); });

  /* ---------- Filters (discography, visuals) ---------- */
  $$('[data-filter-group]').forEach(function (sec) {
    var chips = $$('[data-filter]', sec), items = $$('[data-cat]', sec), track = $('.vis__track', sec);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.getAttribute('data-filter');
        chips.forEach(function (x) { var on = x === c; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        items.forEach(function (it) {
          var show = f === 'all' || it.getAttribute('data-cat') === f;
          it.hidden = !show;
          if (show && !reduce) { it.classList.remove('pop'); void it.offsetWidth; it.classList.add('pop'); }
        });
        if (track) track.scrollLeft = 0;
      });
    });
  });

  /* ---------- Horizontal gallery: arrows, progress, drag ---------- */
  $$('[data-scroller]').forEach(function (sec) {
    var sc = $('.vis__track', sec), prev = $('.vis__prev', sec), next = $('.vis__next', sec), bar = $('.vis__progress span', sec);
    if (!sc) return;
    var moved = false, down = false, sx = 0, sl = 0;
    function upd() {
      var max = sc.scrollWidth - sc.clientWidth;
      bar.style.transform = 'scaleX(' + (max > 0 ? clamp(sc.scrollLeft / max, 0, 1) : 1).toFixed(3) + ')';
      prev.disabled = sc.scrollLeft < 4; next.disabled = sc.scrollLeft > max - 4;
    }
    sc.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd); upd();
    prev.addEventListener('click', function () { sc.scrollBy({ left: -sc.clientWidth * .8, behavior: reduce ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { sc.scrollBy({ left: sc.clientWidth * .8, behavior: reduce ? 'auto' : 'smooth' }); });
    sc.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; sx = e.clientX; sl = sc.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 5) { moved = true; sc.classList.add('is-drag'); }
      if (moved) sc.scrollLeft = sl - dx;
    });
    window.addEventListener('pointerup', function () { down = false; sc.classList.remove('is-drag'); });
    sc.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  /* ---------- Lightbox ---------- */
  var lb = $('#lightbox');
  if (lb) {
    var lbImg = $('img', lb), lbCap = $('figcaption', lb), lbCount = $('.lightbox__count', lb);
    var lbClose = $('.lightbox__close', lb), lbPrev = $('.lightbox__prev', lb), lbNext = $('.lightbox__next', lb);
    var items = [], idx = 0, opener = null, tx = 0;
    var show = function (i) {
      idx = (i + items.length) % items.length;
      var it = items[idx];
      lbImg.classList.remove('is-in');
      lbImg.onload = function () { lbImg.classList.add('is-in'); };
      lbImg.src = it.getAttribute('data-full');
      lbImg.alt = it.getAttribute('data-alt') || '';
      lbCap.textContent = it.getAttribute('data-caption') || '';
      lbCount.textContent = (idx + 1) + ' / ' + items.length;
      var n = items[(idx + 1) % items.length]; if (n) { var pre = new Image(); pre.src = n.getAttribute('data-full'); }
    };
    var openLb = function (btn) {
      var scope = btn.closest('[data-lightbox-scope]') || d;
      items = $$('[data-lightbox]', scope).filter(function (e) { return !e.hidden; });
      opener = btn; lb.hidden = false; d.body.classList.add('lb-open');
      lbPrev.hidden = lbNext.hidden = items.length < 2;
      show(Math.max(0, items.indexOf(btn))); lbClose.focus();
    };
    var closeLb = function () { lb.hidden = true; d.body.classList.remove('lb-open'); lbImg.removeAttribute('src'); if (opener) opener.focus(); };
    d.addEventListener('click', function (e) { var b = e.target.closest('[data-lightbox]'); if (b) openLb(b); });
    lbClose.addEventListener('click', closeLb);
    lbPrev.addEventListener('click', function () { show(idx - 1); });
    lbNext.addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    lb.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 50 && items.length > 1) show(idx + (dx < 0 ? 1 : -1)); }, { passive: true });
    d.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowRight' && items.length > 1) show(idx + 1);
      else if (e.key === 'ArrowLeft' && items.length > 1) show(idx - 1);
      else if (e.key === 'Tab') {
        var f = [lbClose, lbPrev, lbNext].filter(function (x) { return !x.hidden; });
        var i = f.indexOf(d.activeElement);
        e.preventDefault();
        f[(i + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
  }

  /* ---------- Audio player + visualizer (user-initiated only) ---------- */
  var activePlayer = null;
  $$('[data-player]').forEach(function (p) {
    var src = p.getAttribute('data-src');
    var btn = $('.player__btn', p), seek = $('.player__seek', p), time = $('.player__time', p), status = $('.player__status', p), cv = $('.player__viz', p);
    var audio = null, ctx = null, analyser = null, data = null, raf = 0, cors = true, wired = false;
    var fmt = function (s) { s = Math.floor(s || 0); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); };
    var say = function (t) { status.textContent = t || ''; };
    var api = { pause: function () { if (audio && !audio.paused) { audio.pause(); setPlaying(false); } } };

    function setPlaying(on) {
      p.classList.toggle('is-playing', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Pause' : 'Play');
      cancelAnimationFrame(raf);
      if (on && analyser && !reduce) draw();
      if (!on) { root.style.setProperty('--pulse', '0'); if (cv) cv.getContext('2d').clearRect(0, 0, cv.width, cv.height); }
    }
    function draw() {
      raf = requestAnimationFrame(draw);
      analyser.getByteFrequencyData(data);
      var c = cv.getContext('2d'), w = cv.width, h = cv.height, n = data.length, bw = w / n, sum = 0;
      c.clearRect(0, 0, w, h);
      for (var i = 0; i < n; i++) {
        var v = data[i] / 255; sum += v;
        var bh = Math.max(2, v * h);
        c.fillStyle = 'rgba(212,175,55,' + (.3 + v * .7).toFixed(2) + ')';
        c.fillRect(i * bw + 1, (h - bh) / 2, Math.max(1, bw - 2), bh);
      }
      root.style.setProperty('--pulse', clamp(sum / n * 1.6, 0, 1).toFixed(3));
    }
    function wire() {
      if (wired || !cors) return;
      try {
        var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return;
        ctx = ctx || new AC();
        var node = ctx.createMediaElementSource(audio);
        analyser = ctx.createAnalyser(); analyser.fftSize = 128;
        node.connect(analyser); analyser.connect(ctx.destination);
        data = new Uint8Array(analyser.frequencyBinCount); wired = true;
      } catch (e) { analyser = null; }
    }
    function make() {
      audio = new Audio(); audio.preload = 'none';
      if (cors) audio.crossOrigin = 'anonymous';
      audio.src = src; wired = false; analyser = null;
      audio.addEventListener('timeupdate', function () {
        if (audio.duration) seek.value = Math.round(audio.currentTime / audio.duration * 1000);
        time.textContent = fmt(audio.currentTime);
      });
      audio.addEventListener('waiting', function () { say('Loading...'); });
      audio.addEventListener('playing', function () { say(''); });
      audio.addEventListener('ended', function () { setPlaying(false); seek.value = 0; time.textContent = '0:00'; });
      audio.addEventListener('error', function () {
        if (cors) { cors = false; make(); start(); }
        else { say("Couldn't load the audio."); setPlaying(false); }
      });
    }
    function start() {
      if (activePlayer && activePlayer !== api) activePlayer.pause();
      activePlayer = api; wire();
      if (ctx && ctx.state === 'suspended') ctx.resume();
      say('Loading...');
      var pr = audio.play(); if (pr && pr.catch) pr.catch(function () { say("Couldn't play the audio."); setPlaying(false); });
      setPlaying(true);
    }
    btn.addEventListener('click', function () {
      if (!audio) make();
      if (audio.paused) start(); else { audio.pause(); setPlaying(false); }
    });
    seek.addEventListener('input', function () { if (audio && audio.duration) audio.currentTime = seek.value / 1000 * audio.duration; });
  });

  /* ---------- Easter egg: type "loww" ---------- */
  var egg = $('#egg'), eggRain = null, buf = '', eggTimer = 0;
  function closeEgg() { if (!egg || egg.hidden) return; egg.hidden = true; clearTimeout(eggTimer); if (eggRain) eggRain.stop(); }
  function openEgg() {
    if (!egg || !egg.hidden) return;
    egg.hidden = false;
    if (!reduce && !saveData) {
      var cv = $('canvas', egg);
      if (!eggRain) eggRain = Rain(cv, { size: 20, fade: .07, fps: 30, speed: 1, glyphs: 'LOWW01ｱｲｳｴｵ', ghost: .12 });
      eggRain.resize(); eggRain.start();
    }
    eggTimer = setTimeout(closeEgg, 8000);
  }
  if (egg) {
    egg.addEventListener('click', closeEgg);
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeEgg();
      var t = (e.target && e.target.tagName) || '';
      if (/input|textarea|select/i.test(t) || e.key.length !== 1) return;
      buf = (buf + e.key.toLowerCase()).slice(-4);
      if (buf === 'loww') { buf = ''; openEgg(); }
    });
  }

  /* ---------- Motion layer ---------- */
  var targets = $$('.reveal, .wipe, h2.sweep, .section, [data-words]');
  var sections = $$('.section');

  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('in'); });
    sections.forEach(function (el) { el.classList.add('in-view'); });
    $$('[data-portal]').forEach(function (s) { s.style.setProperty('--portal', '1'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); if (e.target.classList.contains('section')) e.target.classList.add('in-view'); io.unobserve(e.target); } });
  }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
  targets.forEach(function (el) { io.observe(el); });
  var so = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in-view'); so.unobserve(e.target); } });
  }, { threshold: 0.05 });
  sections.forEach(function (el) { so.observe(el); });

  var hero = $('.hero'), portals = $$('[data-portal]'), drifts = $$('.statement__text'), tracks = $$('.marquee__track');
  var lastY = window.scrollY || 0, vel = 0, rate = 1, running = false;
  function setRate(r) { tracks.forEach(function (t) { var a = t.getAnimations && t.getAnimations()[0]; if (a) a.playbackRate = r; }); }

  function frame() {
    var y = window.scrollY || 0, vh = window.innerHeight;
    root.style.setProperty('--p', clamp(y / Math.max(1, root.scrollHeight - vh), 0, 1).toFixed(4));
    if (hero) {
      var k = clamp(y / (hero.offsetHeight || 1), 0, 1);
      hero.style.setProperty('--wy', (y * 0.12).toFixed(1) + 'px');
      hero.style.setProperty('--wo', (1 - k * 0.9).toFixed(3));
      hero.style.setProperty('--ls', (k * 0.5).toFixed(3));
    }
    portals.forEach(function (s) {
      var r = s.getBoundingClientRect(), p = clamp(-r.top / Math.max(1, r.height - vh), 0, 1);
      s.style.setProperty('--portal', p.toFixed(4));
      if (s._rain) { if (r.bottom > 0 && r.top < vh && p < .92) s._rain.start(); else s._rain.stop(); }
    });
    drifts.forEach(function (el, i) {
      var r = el.getBoundingClientRect(); if (r.bottom < -50 || r.top > vh + 50) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.setProperty('--sx', (c * (i % 2 ? -1 : 1) * 6).toFixed(2) + 'vw');
    });
    vel = y - lastY; lastY = y;
    rate += ((1 + Math.min(6, Math.abs(vel) * 0.35)) - rate) * 0.12;
    setRate(rate);
    if (Math.abs(rate - 1) > 0.02 || Math.abs(vel) > 0.5) requestAnimationFrame(frame);
    else { rate = 1; setRate(1); running = false; }
  }
  function kick() { if (running) return; running = true; requestAnimationFrame(frame); }
  window.addEventListener('scroll', kick, { passive: true });
  window.addEventListener('resize', kick);
  kick();

  /* ---------- Pointer effects (desktop) ---------- */
  if (fine) {
    var cur = d.createElement('div');
    cur.className = 'cursor'; cur.setAttribute('aria-hidden', 'true'); d.body.appendChild(cur);
    var mx = -100, my = -100, cx = -100, cy = -100;
    var letters = $$('.hero .ch');
    window.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      if (hero) {
        hero.style.setProperty('--mx', ((mx / window.innerWidth) * 2 - 1).toFixed(3));
        hero.style.setProperty('--my', ((my / window.innerHeight) * 2 - 1).toFixed(3));
        letters.forEach(function (l) {
          var r = l.getBoundingClientRect();
          var dist = Math.hypot(mx - (r.left + r.width / 2), my - (r.top + r.height / 2));
          l.style.setProperty('--k', clamp(1 - dist / 260, 0, 1).toFixed(3));
        });
      }
    }, { passive: true });
    (function loop() {
      cx += (mx - cx) * 0.18; cy += (my - cy) * 0.18;
      cur.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      requestAnimationFrame(loop);
    })();
    d.addEventListener('mouseover', function (e) {
      var lab = e.target.closest('[data-cursor]');
      cur.textContent = lab ? lab.getAttribute('data-cursor') : '';
      cur.classList.toggle('has-label', !!lab);
      cur.classList.toggle('is-hover', !lab && !!e.target.closest('a, button, .vis__item, .disco__item'));
    });
    $$('.btn, .pill').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * 0.25).toFixed(1) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * 0.35).toFixed(1) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
    $$('.disco__item').forEach(function (it) {
      var c = $('.disco__cover', it);
      it.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--tx', (((e.clientX - r.left) / r.width) * 2 - 1).toFixed(2));
        c.style.setProperty('--ty', (((e.clientY - r.top) / r.height) * 2 - 1).toFixed(2));
      });
      it.addEventListener('mouseleave', function () { c.style.setProperty('--tx', 0); c.style.setProperty('--ty', 0); });
    });
  }
})();
